export default __webpack_public_path__ + "689377f40068d8311de8bee6a0e9be2d.png";